<template>
  <main>
    <h1
      class="text-xl w-full bg-gray-100 text-[#283A61] font-bold text-center uppercase m-auto"
    >
      <span class="block m-auto p-4"
        >Bienvenue sur le site dédié aux offres Husqvarna !</span
      >
    </h1>
    <div class="font-semibold text-center w-full" v-if="loading">
      <span class="block">Chargement en cours ...</span>
    </div>

    <div
      class="m-auto grid grid-cols-1 md:grid-cols-2 gap-6 my-6 xl:my-10 max-w-5xl px-4"
    >
      <template v-for="op in results">
        <div
          class="w-full bg-gray-100"
          :class="`op-${op._id}`"
          :key="op._id"
          v-if="op.isActive && !loading"
        >
          <div v-if="op.banner_mb" class="w-full">
            <img :src="op.banner_mb" class="w-full" />
          </div>

          <div class="mb-4 w-full text-center relative z-20 p-4">
            <h2 class="font-bold pt-6 pb-2 text-xl text-[#283A61]">
              {{ op.title }}
            </h2>
            <p class="text-base font-bold text-gray-600">
              Du {{ op.date_debut }} au
              {{ op.date_fin_achat }}
            </p>
 


            <!-- Bouton pour opération 68760d9231332264387c136e avec compteurs par produit -->
            <router-link
              v-if="op._id === '68760d9231332264387c136e' && op.forms && op.forms.length > 0 && op.productCounters && (limit - op.productCounters.r4 > 0 || limit - op.productCounters.am310 > 0 || limit - op.productCounters.am315 > 0)"
              :to="`/form/${op._id}`"
              ><button class="button uppercase font-bold mt-4">
                je remplis le formulaire &nbsp;
              </button></router-link
            >

            <!-- Bouton pour opération 68907ff8b745780eb4643fe1 avec compteur result -->
            <router-link
              v-if="op._id === '68907ff8b745780eb4643fe1' && op.productCounters && op.productCounters.result < 4000"
              :to="`/form/${op._id}`"
              ><button class="button uppercase font-bold mt-4">
                je remplis le formulaire &nbsp;
              </button></router-link
            >

            <!-- Bouton pour les autres opérations normales -->
            <router-link
              v-if="op._id !== '68760d9231332264387c136e' && op._id !== '68907ff8b745780eb4643fe1' && op.forms && op.forms.length > 0"
              :to="`/form/${op._id}`"
              ><button class="button uppercase font-bold mt-4">
                je remplis le formulaire &nbsp;
              </button></router-link
            >
      

            <template v-if="op._id === '68760d9231332264387c136e'" >
              <div class="bg-gray-200 pt-1 mt-4 pb-1 rounded-lg p-0">
              <p class="text-base text-center w-[90%] m-auto mt-4 text-gray-600 font-semibold">
                *Unités disponibles par gamme :
              </p>
              <ul class="flex justify-between w-full max-w-sm m-auto mt-4 gap-6 text-gray-600  py-2 px-4 rounded-lg font-semibold">
                <li class="badge"><span>{{ Math.max(0, limit-op.productCounters?.r4 || 0) }}</span> R4</li>
                <li class="badge"><span>{{ Math.max(0, limit-op.productCounters?.am305 || 0) }}</span> AM305</li>
                <li class="badge"><span>{{ Math.max(0, limit-op.productCounters?.am310 || 0) }}</span> AM310</li>
                <li class="badge"><span>{{ Math.max(0, limit-op.productCounters?.am315 || 0) }}</span> AM315</li>
              </ul>
              </div>
            </template>
            <template v-if="op._id === '68907ff8b745780eb4643fe1'" >
              <div class="bg-gray-200 pt-1 mt-4 pb-1 rounded-lg p-0">
              <p class="text-base text-center  m-auto my-2 text-gray-600 font-semibold flex w-full items-center justify-center">
                *Unités disponibles  :
                <span class="badge block ml-2"><span class="block mb-2">{{ Math.max(0, 4000 - (op.productCounters?.result || 0)) }}</span></span>

              </p>
              </div>
            </template>
            <template v-if="op._id === '6939885452a281612e7ea5c5' && op.allProductCounters">
              <div class="bg-gray-200 pt-4 mt-4 pb-4 rounded-lg">
                <p class="text-base text-center w-[90%] m-auto text-gray-600 font-semibold">
                  *Unités disponibles par gamme :
                </p>
                <ul class="grid grid-cols-2 gap-3 w-full max-w-md m-auto mt-4 text-gray-600 px-4 font-semibold">
                  <li v-for="counter in op.allProductCounters" :key="counter.product" class="bg-white rounded-lg py-3 px-2 text-center shadow-sm">
                    <span class="bg-blue-200 rounded-lg px-3 py-1 text-sm font-bold text-[#283A61] inline-block mb-2">{{ Math.max(0, counter.value || 0) }}</span>
                    <span class="block text-xs text-gray-700">{{ counter.product }}</span>
                  </li>
                </ul>
              </div>
            </template>
            <template v-if="op._id === '693989b9a310d81c44e73407' && op.allProductCounters">
              <div class="bg-gray-200 pt-4 mt-4 pb-4 rounded-lg">
                <p class="text-base text-center w-[90%] m-auto text-gray-600 font-semibold">
                  *Unités disponibles par gamme :
                </p>
                <ul class="grid grid-cols-2 gap-3 w-full max-w-md m-auto mt-4 text-gray-600 px-4 font-semibold">
                  <li v-for="counter in op.allProductCounters" :key="counter.product" class="bg-white rounded-lg py-3 px-2 text-center shadow-sm">
                    <span class="bg-blue-200 rounded-lg px-3 py-1 text-sm font-bold text-[#283A61] inline-block mb-2">{{ Math.max(0, counter.value || 0) }}</span>
                    <span v-if="counter.category" class="block text-xs text-gray-500 mt-1">{{ counter.category }}</span>
                  </li>
                </ul>
              </div>
            </template>
            
            <div
              v-if="op._id === '68760d9231332264387c136e' && op.productCounters && limit-op.productCounters.r4 <= 0 && limit-op.productCounters.am310 <= 0 && limit-op.productCounters.am315 <= 0"
              class="text-base w-[95%] md:w-[70%] m-auto mt-4 py-2 rounded px-4 border bg-red-100 border-red-300 text-red-800"
            >
              <span class="text-sm block !leading-2">
                Le compteur de participation a été atteint pour toutes les gammes, vous ne pouvez plus participer à l'offre de remboursement.
              </span>
            </div>

            <p
              class="mt-4 uppercase italic text-xs text-[#283A61] font-semibold"
            >
              <a
                :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/${op._id}/modalites.pdf`"
                target="_blank"
                >voir les modalités</a
              >
            </p>
            <!-- <p
              v-if="op.counters && op.counters.length > 0"
              class="text-sm text-justify w-[90%] m-auto mt-4 italic text-gray-600"
            >
              *Une fois le nombre de participants atteint, vous pourrez toujours
              participer au tirage au sort.
            </p> -->
          </div>
        </div>
      </template>
    </div>
    <div
      class="w-full text-center font-semibold text-gray-700"
      v-if="!active "
    >
      Aucune offre actuellement disponible.
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const hostname = window.location.hostname;
const active = ref(false);
const loading = ref(false);

// Domaines d'exception pour le développement/test
// husqvarna-multi-2025.pages.dev
// test.husqvarna-operation30ans.fr
// localhost

const limit = 1000;

// husqvarna-multi-2025.pages.dev

const operationsId = [
{
    _id: "68760d9231332264387c136e",
  },
  {
    _id: "68907ff8b745780eb4643fe1",
  },
  {
    _id: "6939885452a281612e7ea5c5",
  },
  {
    _id: "693989b9a310d81c44e73407",
  },
  {
    _id: "696fa1e827dd902d7e2e459d",
  },
];

const results = ref([]);

const fetchOperation = async (_id) => {
  try {
    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/v2/formdata/${_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();
    const modifiedData = transformData(data);

    return modifiedData;
  } catch (error) {
    console.error(`Erreur lors de la requête pour l'ID ${_id}:`, error);
    throw error;
  }
};

const isDateBetween = (startDate, endDate) => {
  const todayStart = dayjs().startOf('day');
  const todayEnd = dayjs().endOf('day');
  const start = dayjs(startDate, "DD/MM/YYYY").startOf('day');
  const end = dayjs(endDate, "DD/MM/YYYY").endOf('day');

  // date_debut 00h00 <= aujourd'hui 00h00 ET aujourd'hui 23h59 <= date_fin 23h59
  return !todayStart.isBefore(start) && !todayEnd.isAfter(end);
};

const fetchProductCounters = async (operationName) => {
  try {
    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/operations-custom/${operationName}/product-counters`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();
    console.log('Product counters data:', data);
    return data.data; // Retourner directement l'objet data qui contient les compteurs
  } catch (error) {
    console.error("Erreur lors de la récupération des compteurs de produits:", error);
    return null;
  }
};

const fetchAllProductCounters = async (operationId) => {
  try {
    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/operations-custom/husqvarna-multi-2026/all-product-counters/${operationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();
    console.log('All product counters data:', data);
    return data.counters;
  } catch (error) {
    console.error("Erreur lors de la récupération des compteurs de produits:", error);
    return null;
  }
};

const transformData = async (data) => {
  data.title = data.title.includes(" - ") ? data.title.split(" - ")[1] : data.title;
  data.date_debut = dayjs(data.date_debut).locale("fr").format("DD/MM/YYYY");
  data.date_fin = dayjs(data.date_fin).locale("fr").format("DD/MM/YYYY")
  data.date_fin_achat = data.date_fin_achat ? dayjs(data.date_fin_achat).locale("fr").format("DD/MM/YYYY") : data.date_fin;

  // Vérifier si l'opération a commencé et n'est pas terminée
  let isok = true;

  // Sur les environnements de test, afficher toutes les opérations (en cours ET à venir)
  // En production, afficher uniquement les opérations en cours
  const isTestEnv = hostname === 'test.husqvarna-operation30ans.fr' || hostname === 'localhost';

  if (!isTestEnv) {
    // En production : vérifier que l'opération est en cours
    isok = isDateBetween(data.date_debut, data.date_fin);
    console.log('isok', isok, data);
  }

  if (data.files && data.files.length > 0) {
    const bannerMb = data.files.find((file) => file.filename === "banner_mb");
    data.banner_mb = bannerMb ? bannerMb.uri : null;
  }

  if (data.forms && data.forms.length > 0) {
    data.forms = data.forms.filter((form) => form.type === "CREATE");
  }

  // Vérifier si date_fin_regule est passée
  if (data.date_fin_regule) {
    const dateFinRegule = dayjs(data.date_fin_regule);
    if (dayjs().isAfter(dateFinRegule.endOf('day'))) {
      isok = false;
    }
  }

  // Activer toutes les opérations si leurs dates sont valides
  if (isok) {
    data.isActive = true;
    data.order = 1;
  }

  // Définir l'ordre pour l'opération spéciale
  if (data._id === "67adc20f9ecf132282bfa2e5" && isok) {
    data.order = 2;
  }

  if (data.isActive) {
    let counter;
    let counter2;
    if (data.counters && data.counters.length > 0) {
      counter = await fetch(
        `https://api.husqvarna-promo.fr/api/v2/counters/${data._id}/${data.counters[0].name}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      counter = await counter.json();
      if (counter.value < 0) counter.value = 0;
      data.counter = counter.value;
    }

    if (data.counters && data.counters.length > 1) {
      counter2 = await fetch(
        `https://api.husqvarna-promo.fr/api/v2/counters/${data._id}/${data.counters[1].name}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      counter2 = await counter2.json();
      if (counter2.value < 0) counter2.value = 0;
      data.counter2 = counter2.value;
    }
    
    // Récupérer les compteurs de produits uniquement pour l'opération spécifique
    if (data._id === '68760d9231332264387c136e') {
      const productCounters = await fetchProductCounters('2025-husqvarna-396');
      console.log('Fetched product counters:', productCounters);
      if (productCounters) {
        // S'assurer que les valeurs ne sont jamais négatives
        data.productCounters = {
          r4: Math.max(0, productCounters.r4 || 0),          
          am305: Math.max(0, productCounters.am305 || 0),
          am310: Math.max(0, productCounters.am310 || 0),
          am315: Math.max(0, productCounters.am315 || 0)
        };
        console.log('Data with product counters:', data);
      }

    }
    if (data._id === '68907ff8b745780eb4643fe1') {
      data.productCounters = await fetchProductCounters('2025-husqvarna-412');
    }
    if (data._id === '6939885452a281612e7ea5c5') {
      data.allProductCounters = await fetchAllProductCounters('6939885452a281612e7ea5c5');
      if (data.allProductCounters) {
        const nera320 = data.allProductCounters.find(c => c.product === 'ROBOT 320 NERA');
        if (nera320) nera320.value = 0;
      }
    }
    if (data._id === '696fa1e827dd902d7e2e459d') {
      data.allProductCounters = await fetchAllProductCounters('696fa1e827dd902d7e2e459d');
    }
    if (data._id === '693989b9a310d81c44e73407') {
      data.allProductCounters = await fetchAllProductCounters('693989b9a310d81c44e73407');
    }
    console.log('Data with product counters2:', data);
  }

  return data; // À modifier selon vos besoins
};

const fetchAllOperations = async () => {
  try {
    loading.value = true;
    active.value = false;
    const promises = operationsId.map((op) => fetchOperation(op._id));
    const results = await Promise.all(promises);
    const sortedResults = results
      .filter((operation) => operation.isActive)
      .sort((a, b) => a.order - b.order);

    loading.value = false;

    if (sortedResults.length > 0) {
      active.value = true;
    }

    return sortedResults;
  } catch (error) {
    loading.value = false;
    console.error("Erreur lors du traitement des opérations:", error);
    throw error;
  }
};

fetchAllOperations()
  .then((fetchedResults) => {
    results.value = fetchedResults;
  })
  .catch((error) => {
    console.error("Une erreur est survenue:", error);
  });
</script>

<style scoped>
.badge span {
  @apply bg-blue-200 rounded-lg px-2 py-1 block w-12 mx-auto mt-2;
}

.badge {
  @apply bg-white rounded-lg w-20;
}
</style>